import { render, staticRenderFns } from "./SendVideoFileToKodiDialog.vue?vue&type=template&id=d1facda2"
import script from "./SendVideoFileToKodiDialog.vue?vue&type=script&lang=ts"
export * from "./SendVideoFileToKodiDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports